import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
 
export default new Vuex.Store({
  state:{
    count:0,
    path : '/',
    isLogin:false,
    column_map:{},
    permissions:[]
  },
  mutations:{
    increment:state => state.count ++,
    decrement:state => state.count --,
    setPath:(state,path) => state.path = path,
    login:(state) => state.isLogin = true,
    logout:(state) => state.isLogin = false,
    column_map(state,payload){
        state.column_map[payload.key] = payload.value;
    },
    permissions(state,payload){
        state.permissions = payload;
    }
  },
  plugins: [createPersistedState()]
})


// WEBPACK FOOTER //
// ./src/store/store.js